module.exports = __webpack_public_path__ + "media/images/svg/info-7e26d2aa008ee2f521684a81569e78a2.svg";